
import React from 'react';
import ReactDOM from 'react-dom/client';

import './styles/tokens.css';
import './styles/base.css';
import './styles/layout.css';
import './styles/forms.css';
import './styles/tables.css';
import './styles/components/buttons.css';
import './styles/components/cards.css';
import './styles/components/badges.css';
import './styles/pages/dashboard.css';
import './styles/pages/strategy.css';


import App from './app/index.js';


ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App.Meta.Identity />
  </React.StrictMode>
);